<template>
    <div class="fluid">
        <h1 class="app-title">MIGRAÇÃO DE GUIAS DO SISTEMA ANTIGO</h1>
        <b-card>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            @toggleColuna="toggleColuna"/>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="mb-3 col-2" style="float:right"></b-form-select>
                    <b-button class="ml-2" variant="secondary" @click="limparFiltros"
                              style="float: right; margin-right: 10px; height: 32px; padding: 0 0.75rem;">
                        <i class="fas fa-broom"></i> Limpar Filtros
                    </b-button>
                </b-col>
            </b-row>
            <TabelaMigracaoGuias
                    :resultado="items"
                    :fields="fields"
                    :configTable="configTable"
                    :selecteds="selecteds"
                    :lista-tipo-requisicao="dados.listaTipoRequisicao"
                    :filtro="filtros"
                    @openFilterPopup="openFilterPopup"
                    @consultar="consultar"/>
            <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <div class="registros-encontrados">
                        <span>Requisições Encontradas</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{configTable.perPage != 'Todos' ? configTable.rows : items.length}}</span>
                    </div>

                    <div class="registros-encontrados" style="margin-left: 15px">
                        <span>Requisições Selecionadas</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{selecteds.length}}</span>
                    </div>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col md="3"></b-col>
                <b-col md="6">
                    <div class="d-flex justify-content-between align-items-center">
                        <div style="margin: auto">
                            <b-button class="ml-2" @click="sincronizar" variant="primary">
                                <i class="fas fa-sync-alt"></i> Sincronizar
                            </b-button>
                            <b-button class="ml-2" v-b-modal.modal-confirmar variant="primary" :disabled="selecteds.length == 0">
                                <i class="fas fa-download"></i> Migrar
                            </b-button>
                            <b-button class="ml-2" @click="abrirModalTipoRequisicao" variant="primary" :disabled="selecteds.length == 0">
                                <i class="fas fa-edit"></i> Alterar Tipo de Requisição
                            </b-button>
                            <b-button class="ml-2" @click="abrirModalNumeroProcesso" variant="primary" :disabled="habilitarBotoes">
                                <i class="fas fa-edit"></i> Editar n° Proc.
                            </b-button>
                        </div>
                    </div>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-card>
        <b-modal
                ref="modal-numero-processo"
                id="modal-numero-processo"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Alterar Número do Processo"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <div id="messages" v-if="messageModal !== null">
                        <b-alert show variant="danger">{{ messageModal }}</b-alert>
                    </div>
                </b-col>
                <b-col xs="12" md="12" class="mx-auto">
                    <b-row>
                        <b-col sm="12" md="4" >
                            <b-form-group
                                    label="Informe o número do processo:"
                                    label-for="cnj"
                                    class="text-label"
                                    id="col-cnj"
                                    description="Somente os números">
                                <b-form-input
                                        type="text"
                                        id="cnj"
                                        v-model="cnj"
                                        v-mask="['#######-##.####.#.##.####']"
                                        @change="preencherCnjComZerosEsquerda()"
                                        @mouseout="falsoClick()"
                                        @blur="falsoClick()"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-numero-processo')">Voltar</b-button>
                <b-button variant="primary" @click="alterarNumeroProcesso" class="mr-2">Confirmar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-tipo-requisicao"
                id="modal-tipo-requisicao"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Alterar Tipo de Requisição"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <div id="messagesRequisicao" v-if="messageModal !== null">
                        <b-alert show variant="danger">{{ messageModal }}</b-alert>
                    </div>
                </b-col>
                <b-col xs="12" md="12" class="mx-auto">
                    <b-row>
                        <b-col sm="12" md="4">
                            <b-form-group
                                    label="Tipo de Requisição:"
                                    label-for="tipoRequisicao"
                                    class="text-label">
                                <b-form-select v-model="tipoRequisicao" @change="habilitarInclusaoCda(); limparCdaEGridCda()" 
                                    :class="'mb-3 ' + (!validations.tipoRequisicao.valid ? 'is-invalid' : '')">
                                    <template v-slot:first>
                                        <option :value="null" disabled>Selecionar</option>
                                    </template>
                                    <option
                                            v-for="tc in dados.listaTipoRequisicao"
                                            :key="tc.nome"
                                            :value="tc.nome">
                                        {{ tc.nome ? tc.nome : 'NENHUM' }}
                                    </option>
                                </b-form-select>
                                <div v-if="!validations.tipoRequisicao.valid" class="invalid-message">{{validations.tipoRequisicao.message}}</div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                      
                         <b-col sm="12" md="2" v-if="habilitarCda">
                            <b-form-group label="Número CDA:" label-for="numcda" class="text-label required">
                                <b-form-input type="text" id="numcda" v-model="cda.numeroCda" v-mask="['##########']"
                                    :class="!validations.numeroCda.valid ? 'is-invalid' : ''" />
                                <div v-if="!validations.numeroCda.valid" class="invalid-message">
                                    {{ validations.numeroCda.message }}
                                </div>
                            </b-form-group>
                        </b-col>

                        <b-col sm="12" md="2" style="position: relative;" v-if="habilitarCda">
                            <b-button variant="outline-success" @click="adicionarCda"
                                style="position: absolute; left: 5px; transform:translateY(60%);">
                                <i class="fa fa-plus-circle"></i>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
                <br>
                <b-col sm="12" md="12" v-if="habilitarCda">
                    <b-table id="tableCda" ref="tableCda" :items="listaCdas" :fields="fieldsCda" 
                        striped small responsive :busy="false" show-empty hover bordered sort-icon-left class="mb-3 mt-3" head-variant="light">
                        <div slot="table-busy" class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Carregando...</strong>
                        </div>
                        <template slot="empty">
                            <p class="my-auto">Nenhuma CDA encontrada.</p>
                        </template>
                        <template v-slot:cell(numeroCda)="{ item }">
                            {{ item.numeroCda }}
                        </template>
                        <template v-slot:cell(tipoCredito)="{ item }">
                            {{ item.tipoCredito != null ? item.tipoCredito.nome : "" }}
                        </template>
                        <template v-slot:cell(origem)="{ item }">
                            {{ item.origem }}
                        </template>
                        <template v-slot:cell(status)="{ item }">
                            {{ item.status != null ? item.status : "" }}
                        </template>
                        <template v-slot:cell(valor)="{ item }">
                            <p v-if="item.valor != null">
                                R$ {{ item.valor | currency}}
                            </p>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="fecharModalAlterarRequisicao()">Voltar</b-button>
                <b-button variant="primary"  :disabled="tipoRequisicao == null || (listaCdas.length < 1 && habilitarCda == true)" @click="alterarTipoRequisicao" class="mr-2">Confirmar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-confirmar"
                id="modal-confirmar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Confirmar Migração"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Foram selecionadas {{selecteds.length}} requisições, deseja prosseguir com a migração?</p>
                </b-col>
            </b-row>
            
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-confirmar')"> Voltar</b-button>
                <b-button variant="primary" @click="migrar"> Confirmar</b-button>
            </template>
        </b-modal>
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
        <CompLoading ref="loading"/>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import TabelaMigracaoGuias from "./TabelaMigracaoGuias";
    import CompBotaoExibirOcultarColuna from "../shared/components/CompBotaoExibirOcultarColuna";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import CompLoading from "../shared/components/CompLoading";
    import formatarMixins from '../../mixins/formatarMixins';
    import api from '../../util/api';
    
    export default {
        mixins: [ formatarMixins ],
        components: {CompLoading, CompFiltroGrid, CompBotaoExibirOcultarColuna, TabelaMigracaoGuias, Multiselect},
        data() {
            return {
                urlApi: null,
                token: null,
                messageModal: null,
                cnj: null,
                tipoRequisicao: null,
                habilitarCda: false,
                fields: [
                    {
                        key: "selecionar",
                    }
                ],
                dados: {
                    listaTipoRequisicao: null,
                    tiposCredito: [],
                    status: []
                },
                items: [],
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'cadastroguia.codguia',
                    sortOrder: 'asc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                showColunms: [],
                selecteds: [],
                changed: [],
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    mascara: null,
                    campoTexto: null,
                    campoMascara: null,
                    campoData: null,
                    campoRadio: null,
                    campoCheckbox: null,
                    listaValores: []
                },
                filtros: {
                    codGuia: null,
                    tipoRequisicao: null,
                    filtrarNumeroProcesso: null,
                    numeroProcesso: null,
                    filtrarAnoProcesso: null,
                    anoProcesso: null,
                    cda: null,
                    filtrarContribuinte: null,
                    contribuinte: null,
                    indicadorEf: null,
                },
                validations: {
                    numeroCda: { valid: true, message: "" },
                    tipoRequisicao: { valid: true, message: "" }
                },
                cda: {
                    numeroCda: null,
                    tipoCredito: null,
                    origem: null,
                    status: null,
                    valor: true
                },
               
                listaCdas: [] = [],
                listaCdasTemp: [] = [],
                selectedsCda: [],
                fieldsCda: [
                    {
                        key: 'numeroCda',
                        sortable: true,
                        label: 'CDA.'
                    },
                    {
                        key: 'tipoCredito',
                        sortable: true,
                        label: 'Tipo Crédito'
                    },
                    {
                        key: 'origem',
                        sortable: true,
                        label: 'Origem'
                    },
                    {
                        key: 'status',
                        sortable: true,
                        label: 'Status'
                    },
                    {
                        key: 'valor',
                        sortable: true,
                        label: 'Valor'
                    }
                ],
            }
        },
        methods: {
            async listarTipoRequisicao() {
                axios.get(`${this.urlApi}/v1/pesquisas/listarTipoRequisicao`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.listaTipoRequisicao = response.data;
                })
            },
            async consultar() {
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/importarGuia/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.items = response.data.resultado;
                    this.items.forEach (item => {
                        if (item.numProcesso !== undefined && item.numProcesso !== null && item.numProcesso !== '') {
                            item.numProcesso = item.numProcesso.replace(/\D/g,'');
                            if (item.numProcesso === null || item.numProcesso === '') {
                                item.numProcesso = 0;
                            }
                        }
                    })
                    for(var i = 0; i < this.selecteds.length; i++) {
                        for (var j = 0; j < this.items.length; j++) {
                            if (this.items[j].codGuia == this.selecteds[i].codGuia) {
                                this.items[j] = this.selecteds[i];
                            }
                        }
                    }
                    for(var i = 0; i < this.changed.length; i++) {
                        for (var j = 0; j < this.items.length; j++) {
                            if (this.items[j].codGuia == this.changed[i].codGuia) {
                                this.items[j] = this.changed[i];
                            }
                        }
                    }
                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows;
                        this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                    } else {
                        this.configTable.lastPage = 1;
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },
            async sincronizar() {
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/importarGuia/sincronizar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.items = response.data.resultado;


                    for(var i = 0; i < this.selecteds.length; i++) {
                        for (var j = 0; j < this.items.length; j++) {
                            if (this.items[j].codGuia == this.selecteds[i].codGuia) {
                                this.selecteds[i] = this.items[j];
                            }
                        }
                    }
                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows;
                        this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                    } else {
                        this.configTable.lastPage = 1;
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },
            async migrar() {
                this.$refs['modal-confirmar'].hide();
                this.configTable.load = true;
                await axios.post(`${this.urlApi}/v1/importarGuia/migrar`, this.selecteds, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: 'Operação realizada com sucesso!!!'}]});
                    this.selecteds = [];
                    this.consultar();
                }).catch((error) => {
                    this.exibirErro(error)
                    this.configTable.load = false;
                })
            },
            
            adicionarCda() {
                this.limparErroDeValidacao(this.validations.numeroCda);
                if (this.verificarValorVazio(this.cda.numeroCda)) {
                    this.adicionarErroDeValidacao(this.validations.numeroCda, "Favor preencher os campos obrigatórios!");
                    return;
                }

                for (let i = 0; i < this.listaCdas.length; i++) {
                    if (this.listaCdas[i].numeroCda == this.cda.numeroCda) {
                        this.adicionarErroDeValidacao(this.validations.numeroCda, "CDA já incluída!");
                        return;
                    }
                }
                api.get(`importarGuia/consultarCdaDetalhada/${this.cda.numeroCda}`, this.callbackconsultarCdaDetalhada, this.$refs.loading);
            },

            toggleCheckCda(checked, item) {
                if (checked) {
                    this.selectedsCda.push(item);
                } else {
                    const index = this.selectedsCda.indexOf(item);
                    this.selectedsCda.splice(index, 1);
                }
            },

            limparCda() {
                this.cda = {
                        codPagamentoCda: null,
                        numeroCda: null,
                        situacaoDivida: null,
                        statusCredito: null,
                        tipoCredito: null,
                        indAtivo: true
                    };
            },

            limparCdaEGridCda(){
                this.limparCda();
                this.listaCdas = [];
                this.listaCdasTemp = [];
                this.selectedsCda = [];
                this.limparValidations(this.validations);
            },

            callbackconsultarCdaDetalhada(response){
                if (response.data.mensagemDeErro != null) {
                    let msgErro = response.data.mensagemDeErro;

                    if(response.data.mainframeFih2n844DTO != null && response.data.mainframeFih2n844DTO.codigoChamada != '0000'){
                        let codigoErro = response.data.mainframeFih2n844DTO.codigoChamada;
                        msgErro = `Erro! Repita o processo! Cod. ${codigoErro}`;
                    }

                    this.adicionarErroDeValidacao(this.validations.numeroCda, msgErro);
                    return;
                }
                
                let cdaResponse = response.data.mainframeFih2n844DTO;

                this.cda.status = cdaResponse.descricaoStatus;

                this.cda.tipoCredito = this.dados.tiposCredito.find(tipoCredito => tipoCredito.id == cdaResponse.tipoCredito
                    || tipoCredito.nome.toLowerCase() == cdaResponse.descricaoCredito.toLowerCase());

                this.cda.origem = cdaResponse.descricaoReferencia;
                this.cda.valor = cdaResponse.valorTotal == null ? '0' : this.tratarCamposNumericos(cdaResponse.valorTotal);

                this.listaCdas.push(this.cda);
                this.listaCdasTemp.push(cdaResponse);

                this.selectedsCda = [];
                this.$refs.tableCda.refresh();

                this.limparCda();
            },

            habilitarInclusaoCda(){
                if(!this.selecteds[0]){
                    this.habilitarCda = false;
                    return;
                }
                this.habilitarCda = (this.selecteds[0].tipoRequisicao == 'Honorários de Ação Judicial'
                        || this.selecteds[0].tipoRequisicao == ' Comunicação de Transferência de Ação Judicial')
                    && (this.tipoRequisicao == 'Honorários de EF - Base de Cálculo D.A. SEFA' ||
                        this.tipoRequisicao == 'Comunicação de Transferência de Honorários de EF - Base de Cálculo e D.A. SEFA');
            },

            excluirCda() {
                const index = this.listaCdas.indexOf(this.selectedsCda[0]);

                this.listaCdas.splice(index, 1);
                this.selectedsCda = [];
                this.cda = {
                    codPagamentoCda: null,
                    numeroCda: null,
                    situacaoDivida: null,
                    statusCredito: null,
                    tipoCredito: null,
                    indAtivo: null
                };
            },

            fecharModalAlterarRequisicao(){
                this.$refs['modal-tipo-requisicao'].hide();
                this.listaCdas = [];
                this.listaCdasTemp = [];
                this.selectedsCda = [];
                this.tipoRequisicao = null;
                this.habilitarInclusaoCda();
                this.limparCdaEGridCda();
            },

            prevPage() {
                this.configTable.currentPage = this.configTable.currentPage - 1;
                this.consultar();
            },

            nextPage() {
                this.configTable.currentPage = this.configTable.currentPage + 1;
                this.consultar();
            },

            async obterColunasUsuario() {
                const funcionalidade = 'migracaoGuias';

                axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    response.data.forEach((field, i) => {
                        if (field.ativo) {
                            this.showColunms.push(i + 1)
                        }
                        this.fields.push({
                            key: `${i + 1}`,
                            label: `${field.descricao}`,
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },

            toggleColuna(i) {
                let ativo;
                if (this.showColunms.includes(i)) {
                    this.showColunms.splice(this.showColunms.indexOf(i), 1);
                    this.fields[i].thClass = 'd-none';
                    this.fields[i].tdClass = 'd-none';
                    ativo = false
                } else {
                    this.showColunms.push(i);
                    this.fields[i].thClass = '';
                    this.fields[i].tdClass = '';
                    ativo = true
                }

                this.atualizarConfiguracaoColunm(i, ativo)
            },

            async atualizarConfiguracaoColunm(i, ativo) {
                const json = {
                    codFuncionalidade: this.fields[i].codFuncionalidade,
                    codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                    ativo,
                };
                axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },

            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;
                    if(this.filtro.campoFiltro == 'Guia Antigo') {
                        this.filtro.campoMascara = this.filtros.codGuia;
                    } else if(this.filtro.campoFiltro == 'Tipo de Requisição') {
                        this.filtro.campoCheckbox = this.filtros.tipoRequisicao;
                    } else if(this.filtro.campoFiltro == 'Número do Processo') {
                        this.filtro.filtrarEm = this.filtros.filtrarNumeroProcesso;
                        this.filtro.campoTexto = this.filtros.numeroProcesso;
                    } else if(this.filtro.campoFiltro == 'Ano do Processo') {
                        this.filtro.campoMascara = this.filtros.anoProcesso;
                    } else if(this.filtro.campoFiltro == 'CDAs') {
                        this.filtro.campoTexto = this.filtros.cda;
                    } else if(this.filtro.campoFiltro == 'Contribuinte') {
                        this.filtro.filtrarEm = this.filtros.filtrarContribuinte;
                        this.filtro.campoTexto = this.filtros.contribuinte;
                    } else if(this.filtro.campoFiltro == 'Indicador EF (Sipro)') {
                        this.filtro.campoCheckbox = this.filtros.indicadorEf;
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoMascara = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                    this.filtro.campoCheckbox = null;
                }

                if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                    this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
                }

                if(this.filtro.campoFiltro == 'Guia Antigo') {
                    this.filtros.codGuia = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Tipo de Requisição') {
                    this.filtros.tipoRequisicao = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Número do Processo') {
                    this.filtros.filtrarNumeroProcesso = this.filtro.filtrarEm;
                    this.filtros.numeroProcesso = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Ano do Processo') {
                    this.filtros.anoProcesso = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'CDAs') {
                    this.filtros.cda = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Contribuinte') {
                    this.filtros.filtrarContribuinte = this.filtro.filtrarEm;
                    this.filtros.contribuinte = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Indicador EF (Sipro)') {
                    this.filtros.indicadorEf = this.filtro.campoCheckbox;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Guia Antigo') {
                    this.configTable.sortField = 'cadastroguia.codguia';
                } else if(this.filtro.campoFiltro == 'Tipo de Requisição') {
                    this.configTable.sortField = 'tipoRequisicao';
                } else if(this.filtro.campoFiltro == 'Número do Processo') {
                    this.configTable.sortField = 'cadastroguia.numprocesso';
                } else if(this.filtro.campoFiltro == 'Ano do Processo') {
                    this.configTable.sortField = 'cadastroguia.anoprocesso';
                } else if(this.filtro.campoFiltro == 'CDAs') {
                    this.configTable.sortField = 'cdas';
                } else if(this.filtro.campoFiltro == 'Contribuinte') {
                    this.configTable.sortField = 'cadastroguia.nomeinteressado';
                } else if(this.filtro.campoFiltro == 'Indicador EF (Sipro)') {
                    this.configTable.sortField = 'indicadorSipro';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },
            abrirModalNumeroProcesso() {
                this.messageModal = null;
                this.cnj = null;
                this.$refs['modal-numero-processo'].show();
            },
            alterarNumeroProcesso() {
                if(this.cnj == null || this.cnj.length < 25 || !this.validaCnj(this.cnj)) {
                    this.messageModal = 'CNJ inválido.';
                } else {
                    if(!this.changed.includes(this.selecteds[0])) {
                        this.changed.push(this.selecteds[0]);
                    }

                    this.selecteds[0].numProcesso = this.cnj;
                    this.$refs['modal-numero-processo'].hide();
                }
            },
            abrirModalTipoRequisicao() {
                this.limparValidations(this.validations);
                this.tipoRequisicao = null;
                this.$refs['modal-tipo-requisicao'].show();
            },
            alterarTipoRequisicao() {
                
                this.limparErroDeValidacao(this.validations.tipoRequisicao);
                if(this.tipoRequisicao == null || this.tipoRequisicao == '') {
                    this.adicionarErroDeValidacao(this.validations.tipoRequisicao, 'Selecione um Tipo de Requisição.');
                } else {
                    let cdasNovas =  '';
                    // Possibilitar alterar mais de um.
                    for (let i = 0; i < this.selecteds.length; i++) {
                        cdasNovas = '';
                        if (!this.changed.includes(this.selecteds[i])) {
                            this.changed.push(this.selecteds[i]);
                        }

                        this.selecteds[i].tipoRequisicao = this.tipoRequisicao;
                        if (this.listaCdasTemp.length !== 0) {
                            this.listaCdasTemp.forEach (cda => {
                                cdasNovas += cda.numeroCda + ", ";
                            })
                        }
                        cdasNovas = cdasNovas.slice (0, -2);
                        this.selecteds[i].cdas = cdasNovas;
                        this.selecteds[i].listaCda = this.listaCdasTemp;
                    }
                    //this.selecteds[0].listaCda = this.listaCdasTemp;

                    this.$refs['modal-tipo-requisicao'].hide();
                    this.listaCdas = [];
                    this.listaCdasTemp = [];
                    this.selectedsCda = [];
                    this.tipoRequisicao = null;
                    this.habilitarInclusaoCda();
                }
            },

            async listarTiposCredito() {
                axios.get(`${this.urlApi}/v1/regrasPagamento/listarTiposCredito`, {
                    headers: {'Authorization': this.token}
                }).then(response => this.dados.tiposCredito = response.data)
            },

            async listarStatus() {
                axios.get(`${this.urlApi}/v1/regrasPagamento/listarStatusDivida`, {
                    headers: {'Authorization': this.token}
                }).then(response => this.dados.status = response.data)
            },

            preencherCnjComZerosEsquerda(){
                let element = document.getElementById("cnj");
                if(element.value != null && element.value != ''){
                    let tamanho = element.value.replace(/[^0-9]/g, '').replace(/(\*)\./g, '$1').length;
                    if(22 > tamanho){
                        element.value = Array(21 - tamanho).join('0') + element.value
                    }
                }
            },

            falsoClick(){
                 document.getElementById("cnj").blur();
            },

            limparFiltros() {
                this.filtros = {
                    codGuia: null,
                    tipoRequisicao: null,
                    filtrarNumeroProcesso: null,
                    numeroProcesso: null,
                    filtrarAnoProcesso: null,
                    anoProcesso: null,
                    cda: null,
                    filtrarContribuinte: null,
                    contribuinte: null,
                    indicadorEf: null,
                };

                this.configTable.sortField = 'cadastroguia.codguia';
                this.configTable.sortOrder = 'asc';

                this.consultar();
            }
        },
        watch: {
            perPage() {
                this.configTable.currentPage = 1;
                this.consultar();
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            },
            perPage() {
                return this.configTable.perPage;
            },
            habilitarBotoes() {
                return this.selecteds.length !== 1 || this.selecteds[0].tipoRequisicao == 'Honorários de Protesto';
            }
        },

        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.$store.commit("setMessages", {});

            this.listarTipoRequisicao();
            this.obterColunasUsuario();
            this.consultar();
            this.listarTiposCredito();
            this.listarStatus();
        }
    }
</script>
